module.exports = __webpack_public_path__ + "img/12.b035d748.jpg";